import constants from '../constants';

const { LOCALE_TO_TRIM_REGEXP } = constants.common;

const trimLocaleFromSource = (globalsSource) => globalsSource.replace(LOCALE_TO_TRIM_REGEXP, '$1');

export default trimLocaleFromSource;
